<template>
  <div class="add-user-container">
    <div v-if="!isEdit" class="content">
      <div class="title">{{ $t('addSubscriberAccount') }}</div>

      <div class="form-container">
        <div class="input-title">{{ $t('SIREN') }}</div>
        <input v-model="siren" type="text" class="input" :placeholder="$t('sirenPlaceHolder')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('clientId') }}</div>
        <input v-model="id" type="text" class="input" :placeholder="$t('clientIdPlaceHolder')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('streetNumber') }}</div>
        <input v-model="street" type="text" class="input" :placeholder="$t('streetNumber')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('zipCode') }}</div>
        <input v-model="zipCode" type="text" class="input" :placeholder="$t('zipCode')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('city') }}</div>
        <input v-model="city" type="text" class="input" :placeholder="$t('city')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('country') }}</div>
        <input v-model="country" type="text" class="input" :placeholder="$t('country')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('taxe') }}</div>
        <Dropdown :config="{ inputSize: 48 }" :values="taxes" :placeholder="$t('chooseATaxe')" :on-change="value => (clientTaxe = value)" :value="clientTaxe">
          <template #placeholder="{ value, isPlaceholder }">
            <div v-if="!isPlaceholder">{{ value }}</div>
            <div v-else class="placeholder">{{ value }}</div>
          </template>
          <template #choices="{ choice }">
            <div>{{ choice }}</div>
          </template>
        </Dropdown>
      </div>

      <div class="access-input" @click="confidentialAccess = !confidentialAccess">
        <div class="checkbox" :class="{ checked: confidentialAccess }"></div>
        <div class="checkbox-label">{{ $t('accessToConfidentialData') }}</div>
      </div>
      <div class="access-input" @click="effectiveBeneficiariesAccess = !effectiveBeneficiariesAccess">
        <div class="checkbox" :class="{ checked: effectiveBeneficiariesAccess }"></div>
        <div class="checkbox-label">{{ $t('accessToBeneficiaries') }}</div>
      </div>
      <EmailPreferences v-model="emailPreferences" class="email-preferences" :company="client" :client-creation="true" />

      <div class="btn-container">
        <div class="main-button cancel" @click="$router.go(-1)">
          {{ $t('cancel') }}
        </div>
        <div class="main-button" @click="() => createOrEditCompany(false)">
          {{ $t('addCompany') }}
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div class="title">{{ $t('editSubscriberAccount') }}</div>

      <div class="form-container">
        <div class="input-title">{{ $t('companyName') }}</div>
        <input v-model="name" type="text" class="input" :placeholder="$t('companyName')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('streetNumber') }}</div>
        <input v-model="street" type="text" class="input" :placeholder="$t('streetNumber')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('zipCode') }}</div>
        <input v-model="zipCode" type="text" class="input" :placeholder="$t('zipCode')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('city') }}</div>
        <input v-model="city" type="text" class="input" :placeholder="$t('city')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('country') }}</div>
        <input v-model="country" type="text" class="input" :placeholder="$t('country')" @change="isSend = false" />
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('taxe') }}</div>
        <Dropdown :config="{ inputSize: 48 }" :values="taxes" :placeholder="$t('chooseATaxe')" :on-change="value => (clientTaxe = value)" :value="clientTaxe">
          <template #placeholder="{ value, isPlaceholder }">
            <div v-if="!isPlaceholder">{{ value }}</div>
            <div v-else class="placeholder">{{ value }}</div>
          </template>
          <template #choices="{ choice }">
            <div>{{ choice }}</div>
          </template>
        </Dropdown>
      </div>

      <div class="access-input" @click="confidentialAccess = !confidentialAccess">
        <div class="checkbox" :class="{ checked: confidentialAccess }"></div>
        <div class="checkbox-label">{{ $t('accessToConfidentialData') }}</div>
      </div>

      <div class="access-input" @click="effectiveBeneficiariesAccess = !effectiveBeneficiariesAccess">
        <div class="checkbox" :class="{ checked: effectiveBeneficiariesAccess }"></div>
        <div class="checkbox-label">{{ $t('accessToBeneficiaries') }}</div>
      </div>
      <div class="access-input account" @click="activeAccount = !activeAccount">
        <div class="checkbox" :class="{ checked: activeAccount }"></div>
        <div class="checkbox-label">{{ $t('activatedAccount') }}</div>
      </div>

      <EmailPreferences class="emails" :company="client" />
      <DefaultMonitoringLevel class="monitoring-level" :company="client" />

      <div class="btn-container">
        <div class="main-button cancel" @click="$router.go(-1)">
          {{ $t('cancel') }}
        </div>
        <div class="main-button" @click="() => createOrEditCompany(true)">
          {{ $t('change') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DefaultMonitoringLevel from '@/components/DefaultMonitoringLevel';
import Dropdown from '@/components/Dropdown';
import EmailPreferences from '@/components/EmailPreferences';

export default {
  components: { Dropdown, EmailPreferences, DefaultMonitoringLevel },

  beforeRouteLeave(to, from, next) {
    if (this.isSend) return next();
    if (this.isEdit) {
      if (this.name && this.name !== this.$route.query.name && confirm(this.$t('areYouSureToExit'))) {
        return next();
      } else if (!(this.name && this.name !== this.$route.query.name)) {
        return next();
      }
    } else {
      if (this.siren && confirm(this.$t('areYouSureToExit'))) return next();
      else if (!this.siren) return next();
    }
  },

  props: {
    isEdit: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      siren: '',
      name: '',
      id: '',
      street: '',
      zipCode: '',
      city: '',
      country: '',
      loading: false,
      error: false,
      errorMessage: null,
      isSend: true,
      confidentialAccess: false,
      effectiveBeneficiariesAccess: false,
      activeAccount: true,
      taxes: [],
      clientTaxe: null,
      client: null,
      emailPreferences: {
        alertFrequency: 1,
        mainUserShouldReceiveAlerts: true,
      },
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  async mounted() {
    if (this.$route.query.companyName) {
      this.name = this.$route.query.companyName;
    }
    if (this.$route.query.companyId) this.id = this.$route.query.companyId;

    if (this.id && this.isEdit) {
      this.companies = this.$store.dispatch('getUsers', { id: this.id }).then(client => {
        this.client = client;
        this.confidentialAccess = client.confidentialAccess;
        this.effectiveBeneficiariesAccess = client.effectiveBeneficiariesAccess;
        this.activeAccount = client.isActivated;
        this.clientTaxe = client.taxeName;
        if (client.addressBilling) {
          const address = client.addressBilling.split('|');
          this.street = address[0];
          this.zipCode = address[1];
          this.city = address[2];
          this.country = address[3];
        }
      });
    }
    this.taxes = await this.$store.dispatch('getTaxesLookup');
  },

  methods: {
    async createOrEditCompany(isForEdit) {
      this.isSend = true;
      const address = `${this.street}|${this.zipCode}|${this.city}|${this.country}`;
      await this.$store.dispatch(
        isForEdit ? 'editCompany' : 'addCompany',
        isForEdit
          ? {
              id: this.$route.query.companyId,
              name: this.name,
              confidentialAccess: this.confidentialAccess,
              effectiveBeneficiariesAccess: this.effectiveBeneficiariesAccess,
              taxeName: this.clientTaxe,
            }
          : {
              siren: this.siren,
              id: this.id,
              address,
              taxeName: this.clientTaxe,
              confidentialAccess: this.confidentialAccess,
              effectiveBeneficiariesAccess: this.effectiveBeneficiariesAccess,
              alertFrequency: this.emailPreferences.alertFrequency,
              mainUserShouldReceiveAlerts: this.emailPreferences.mainUserShouldReceiveAlerts,
            },
      );
      if (isForEdit) {
        await this.$store.dispatch('editClient', {
          id: this.$route.query.companyId,
          name: this.name,
          code: this.id,
          address,
          isActivated: this.activeAccount,
          taxeName: this.clientTaxe,
        });
      }
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.add-user-container {
  margin: 60px 0 0;

  .content {
    max-width: 600px;

    .title {
      font-family: fonts.$title-font;
      color: colors.$darkblue-color;
      font-weight: 500;
      font-size: 22px;
      text-align: left;
    }

    .access-input {
      display: flex;
      margin: 16px 0 8px 0;
      cursor: pointer;

      .checkbox-label {
        margin-left: 8px;
      }

      &.account {
        margin-top: 40px;
      }
    }

    .form-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .input-title {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 16px;
        margin: 24px 0 10px 0;
      }

      .input {
        width: 100%;
        height: 48px;
        margin: 0 0 16px;
        padding: 12px 16px;
        box-sizing: border-box;
        color: colors.$text-color;
        border: solid 1px colors.$lightgrey-color;
        border-radius: 4px;
        background: colors.$white-color;

        &:last-child {
          margin: 0;
        }

        &::placeholder {
          color: colors.$lightgrey-color;
        }
      }

      .placeholder {
        color: colors.$lightgrey-color;
      }
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 12px 0 0 0;

      .icon {
        margin: 0 12px 0 0;
        position: relative;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid colors.$lightblue-color;
        flex-shrink: 0;

        &:after {
          position: absolute;
          content: '';
          bottom: 3px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 8px;
          background: colors.$lightblue-color;
        }

        &:before {
          position: absolute;
          content: '';
          top: 3px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 2px;
          background: colors.$lightblue-color;
        }
      }

      .text {
        color: colors.$lightblue-color;
        font-size: 14px;
        opacity: 0.8;
      }
    }

    .btn-container {
      display: flex;
      margin: 80px 0 24px;

      .main-button {
        margin: 0 12px 0;
        width: 200px;
        padding: 0;

        &:hover {
          cursor: pointer;
        }

        &.cancel {
          margin: 0 12px 0 0;
          background: colors.$lightgrey-color;
          color: colors.$darkgrey-color;
        }
      }
    }
  }
}

.emails,
.monitoring-level {
  margin-top: 40px;
}

.email-preferences {
  margin-top: 40px;
}
</style>
